import { getFaces } from '@vlabs/api/luna-api/client';
import { getCards } from '@vlabs/api/point-api/client';

export const PAGE_SIZE = 1000;

export async function fetchFirstPageCardIds(listId: string): Promise<string[]> {
  const response = await getCards({
    page: 1,
    page_size: PAGE_SIZE,
    list_ids: [listId],
    targets: ['card_id'],
  });

  return response.cards?.reduce<string[]>((acc, card) => {
    if (card.card_id) acc.push(card.card_id);
    return acc;
  }, []) ?? [];
}

export async function fetchFirstPageFaceIdsWithoutCards(listId: string): Promise<string[]> {
  const response = await getFaces({
    external_ids: ['', null] as never,
    list_id: listId,
    targets: ['face_id'],
    page: 1,
    page_size: PAGE_SIZE,
  });

  return response.faces?.reduce<string[]>((acc, face) => {
    if (face.face_id) acc.push(face.face_id);
    return acc;
  }, []) ?? [];
}
